import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";
import {generateCartItemsFrom} from "./Cart"




const Products = () => {
  // let logged = (localStorage.getItem("username") != null ? true : false)
  // let username = localStorage.getItem("username");
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */
// let product = {
//   "name":"Tan Leatherette Weekender Duffle",
//   "category":"Fashion",
//   "cost":150,
//   "rating":4,
//   "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
//   "_id":"PmInA797xJhMIPti"
//   }
// TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
//@property {string} productId - Unique ID for the product


const [filteredProducts, setFilteredProducts] = useState([]);
const [allProducts, setAllProducts] = useState([]);
const [loaded, setLoaded] = useState(false);
const {enqueueSnackbar} = useSnackbar();
const [noProducts, setNoProducts] = useState(false);
const [debounceTimeout, setDebounceTimeout] = useState(null);
const [cartItems, setCartItems] = useState([]);
let token = localStorage.getItem("token");


useEffect(()=>{
    fetchCart(token).then((cartData)=>{
      return generateCartItemsFrom(cartData, allProducts);
    }).then((cartProductsFullData)=>{
      setCartItems(cartProductsFullData);
    })
    // eslint-disable-next-line
},[allProducts])



  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */


  const performAPICall = async () => {
    setLoaded(true);
    try{
      let url = `${config.endpoint}/products`
      let resultArray = await axios.get(url);
      setAllProducts(resultArray.data);
      setFilteredProducts(resultArray.data);
      return resultArray.data;
      // enqueueSnackbar(`success`,  {variant:"success"})
    }catch(error){
      // console.log(error)
      enqueueSnackbar(`Something went wrong.`, {variant:"error"})
      return null;
    }finally{
      setLoaded(false);
    }
  };

  useEffect(()=>{
    performAPICall();
    fetchCart(token);
    // eslint-disable-next-line
  },[])

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    setLoaded(true);
    setNoProducts(false);
    try{
    let url = `${config.endpoint}/products/search?value=${text}`
    let requiredArray = await axios.get(url);
    setFilteredProducts(requiredArray.data);
    }catch(error){
      if(error.response.status===404){
        setNoProducts(true);
        }else{
          enqueueSnackbar(`Something went wrong.`, {variant:"error"})
        }
      }finally{
        setLoaded(false);
      }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
   

  const debounceSearch = (event, debounceTimeout) => {
    if(debounceTimeout){
    clearTimeout(debounceTimeout)
    }

    let timer = setTimeout(()=>{
      performSearch(event.target.value);
    },500)

    setDebounceTimeout(timer);
  };



  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    if (!token) return;

    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      let cartResponse = await axios.get(`${config.endpoint}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': `application/json`
        }
      });
      setCartItems(cartResponse.data);
      return cartResponse.data;
      
    } catch (e) { 
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  
  
  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    // console.log(items)
    // console.log(productId)
    let isItem = false;
    items.forEach((item)=>{if(item._id === productId && item.qty>0) isItem = true});
    // console.log(isItem)
    return isItem;
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    // console.log("hello")
    if (!token){
      enqueueSnackbar("Login to add an item to the Cart", { variant: "warning" }); 
      return;
    }
    
  if (options.preventDuplicate && (isItemInCart(items, productId))){
        enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.", { variant: "warning" }); 
      }else{
        let url = `${config.endpoint}/cart`;
        // let postData = {"productId": `${productId}`, "qty":`${qty}`}
        try{
        await axios.post(url, {productId,qty}, {
          headers : {
            Authorization : `Bearer ${token}`,
            'Content-Type' : 'application/json'
          }
        }).then((response)=>{
          // console.log(response.data)
          return response.data;
        }).then((cartData)=>{return generateCartItemsFrom(cartData, products);
      }).then((cartProductsFullData)=>{
        setCartItems(cartProductsFullData);
      })
        }catch(err){
          enqueueSnackbar(err.response.data.message, { variant: "error" }); 
          // console.log(err.response.data.message)
        }
      }
  };


  const loggedOutView = ()=>{
    return ((
      <Grid container>
        <Grid container>
          <Grid item className="product-grid">
          <Box className="hero">
          <p className="hero-heading">
            India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
            to your door step
          </p>
          </Box>
          </Grid>
        </Grid>

      <Grid container padding={2} spacing={2}> 
       {noProducts ? <div className="loading"><SentimentDissatisfied />No products found </div> : (loaded ? <div className="loading"><CircularProgress />Loading Products...</div> :
       filteredProducts.map((product)=>{
        return <Grid item key={product._id} xs={6} md={3}><ProductCard product={product} handleAddToCart = {()=>addToCart(token, cartItems, allProducts, product._id,1,{ preventDuplicate: true })}/></Grid>
       })
      )}
      </Grid>
    </Grid>))
  }

  return (
    <div>
      <Header> <TextField
        className="search-desktop"
        size="small"
        onChange={(e)=>debounceSearch(e, debounceTimeout)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />
      {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
      
      </Header>

      {/* Search view for mobiles */}
      
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        onChange={(e)=>debounceSearch(e, debounceTimeout)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />
       
        { (localStorage.getItem("token") == null) ? loggedOutView() : (<Grid container>
          <Grid container item xs={12} md={9}>

            <Grid container>
              <Grid item className="product-grid">
                <Box className="hero">
                <p className="hero-heading">
                 India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                to your door step
                </p>
                </Box>
              </Grid>
            </Grid>
            
            <Grid container padding={2} spacing={2} marginBottom={1}>
              {noProducts ? <div className="loading"><SentimentDissatisfied />No products found </div> : (loaded ? <div className="loading"><CircularProgress />Loading Products...</div> :
              filteredProducts.map((product)=>{
              return <Grid item key={product._id} xs={6} md={3}><ProductCard product={product} handleAddToCart = {()=>addToCart(token, cartItems, allProducts, product._id,1,{ preventDuplicate: true })}/></Grid>
              })
              )}
            </Grid>
            
          </Grid>
          <Grid container item xs={12} md={3} style={{backgroundColor: `#E9F5E1`}}>
            <Grid item xs={12}> 
            <Cart products = {allProducts} items = {cartItems} handleQuantity = {addToCart}/>
            </Grid>
          </Grid>
        </Grid>
        
        )}
        {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
        
      <Footer />
    </div>
  );
};

export default Products;
